const ENV = import.meta.env.VITE_ENV_NAME

// Traveler web app host per environment: app.51trips.com (prod), app.uat.51trips.com,
// app.dev.51trips.com.
function webAppHost(): string {
    if (ENV === 'dev') return 'https://app.dev.51trips.com'
    if (ENV === 'uat') return 'https://app.uat.51trips.com'
    return 'https://app.51trips.com'
}

// TripBook editor for a trip in the web app.
export const tripBookEditorUrl = (tripId: string): string =>
    `${webAppHost()}/dashboard/trip/${encodeURIComponent(tripId)}`
